const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;

const loadScript = (src) => {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[src="${src}"]`)) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

export const initAnalytics = () => {
  if (typeof window === 'undefined') return;

  if (MEASUREMENT_ID) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`);
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID);
  }

  if (MIXPANEL_TOKEN) {
    loadScript('https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js');
    const attachMixpanel = () => {
      if (window.mixpanel && typeof window.mixpanel.init === 'function' && !window.__msaMixpanelInit) {
        window.mixpanel.init(MIXPANEL_TOKEN, { track_pageview: false });
        window.__msaMixpanelInit = true;
      }
    };
    setTimeout(attachMixpanel, 1000);
  }

  if (HOTJAR_ID && !window.hj) {
    /* eslint-disable */
    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
      h._hjSettings = { hjid: Number(HOTJAR_ID), hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    /* eslint-enable */
  }
};

export const trackPageView = (path) => {
  if (typeof window === 'undefined') return;
  const payload = { page_path: path };

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', payload);
  }
  if (window.mixpanel && typeof window.mixpanel.track === 'function') {
    window.mixpanel.track('page_view', payload);
  }
  if (window.hj) {
    window.hj('event', `page_view_${path.replace(/\W+/g, '_')}`);
  }
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });
  }

  if (window.mixpanel && typeof window.mixpanel.track === 'function') {
    window.mixpanel.track(eventName, params);
  }
  if (window.hj) {
    window.hj('event', eventName);
  }
};

